export const cardSet = [
    {
        id:1,
        title: 'எழுத்துக்கள்',
        subtitle: 'Alphabets',
        avatarSrc: '/images/bookworm.svg',
        imageSrc: '/images/giraffe.png',
        description: 'Learn alphabets in Tamil'
    },
    {
        id:2,
        title: 'பழங்கள்',
        subtitle: 'Fruits',
        avatarSrc: '/images/bookworm.svg',
        imageSrc: '/images/ilandhai_jujube.png',
        description: 'Learn fruits in Tamil'
    },
    {
        id:3,
        title: 'வண்ணங்கள்',
        subtitle: 'colours',
        avatarSrc: '/images/bookworm.svg',
        imageSrc: '/images/violet.png',
        description: 'Learn colours in Tamil'
    },
    {
        id:4,
        title: 'விலங்குகள்',
        subtitle: 'animals',
        avatarSrc: '/images/bookworm.svg',
        imageSrc: '/images/giraffe.png',
        description: 'Learn animals in Tamil'
    },
]

export const flashcards = [
    {
        id: 1,
        cardSetID: 1,
        title: 'அம்மா',
        subtitle: 'amma',
        title_en: 'Mother',
        image: '/images/Amma.png',
        url: '/audio/amma.mp3'
    },
    {
        id: 2,
        cardSetID: 1,
        title: 'அணில்',
        subtitle: 'aNil',
        title_en: 'Squirrel',
        image: '/images/squirrel.png',
        url: '/audio/anil.mp3'
    },
    {
        id: 3,
        cardSetID: 1,
        title: 'ஆடு',
        subtitle: 'Aadu',
        title_en: 'Goat',
        image: '/images/goat.png',
        url: '/audio/aadu.mp3'
    },
    {
        id: 4,
        cardSetID: 1,
        title: 'இலை',
        subtitle: 'ilai',
        title_en: 'leaf',
        image: '/images/leaf.png',
        url: '/audio/ilai.mp3'
    },
    {
        id: 5,
        cardSetID: 1,
        title: 'இட்லி',
        subtitle: 'idli',
        title_en: 'idli',
        image: '/images/idli.png',
        url: '/audio/idli.mp3'
    },
    {
        id: 6,
        cardSetID: 1,
        title: 'ஈட்டி',
        subtitle: 'Eetti',
        title_en: 'Spear',
        image: '/images/Spear.png',
        url: '/audio/Eetti.mp3'
    },
    
    // {
    //     id: 1,
    //     cardSetID: 2, 
    //     title: 'வாழைப்பழம்',
    //     subtitle: 'vaazhaipazham',
    //     title_en: 'banana',
    // },
    // {
    //     id: 2,
    //     cardSetID: 2, 
    //     title: 'திராட்சை',
    //     subtitle: 'draatchai',
    //     title_en: 'grape',
    // },
    // {
    //     id: 1,
    //     cardSetID: 4, 
    //     title: 'எருமை',
    //     subtitle: 'erumai',
    //     title_en: 'buffalo',
    // },
    // {
    //     id: 2,
    //     cardSetID: 4, 
    //     title: 'யானை',
    //     subtitle: 'yaanai',
    //     title_en: 'elephant',
    // },
    // {
    //     id: 1,
    //     cardSetID: 3, 
    //     title: 'சிவப்பு',
    //     subtitle: 'sivappu',
    //     title_en: 'red',
    // },
    // {
    //     id: 2,
    //     cardSetID: 3, 
    //     title: 'ஊதா',
    //     subtitle: 'oodhaa',
    //     title_en: 'violet',
    // },
    
    
]